import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeZone: String, locale: String }

  connect() {
    const options = { hour: "2-digit", minute: "2-digit" }
    if (this.hasTimeZoneValue) options.timeZone = this.timeZoneValue
    try {
      this.formatter = new Intl.DateTimeFormat(this.localeValue || undefined, options)
    } catch {
      this.formatter = new Intl.DateTimeFormat(undefined, { hour: "2-digit", minute: "2-digit" })
    }
    this.updateTime()
    this.interval = setInterval(() => this.updateTime(), 1000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  updateTime() {
    this.element.textContent = this.formatter.format(new Date())
  }
}
